// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"355b86bf","185":"fec3f7a5","554":"e2496cd3","735":"cfd34542","918":"b6ef3594","990":"9d857263"}[chunkId] + ".chunk.js";
};